import React from 'react';
import { Icon } from 'semantic-ui-react';

export function formatNumber(value, digits = 0) {
  return new Intl.NumberFormat('zh-CN', {
    maximumFractionDigits: digits,
  }).format(Number(value || 0));
}

export function formatTokens(value) {
  const tokens = Number(value || 0);
  if (tokens >= 100000000) return `${formatNumber(tokens / 100000000, 2)} 亿`;
  if (tokens >= 10000) return `${formatNumber(tokens / 10000, 2)} 万`;
  return formatNumber(tokens);
}

const metrics = [
  ['model-tone-blue', 'cubes', '模型总数', 'total_model_count', formatNumber],
  ['model-tone-green', 'check circle', '启用模型', 'enabled_model_count', formatNumber],
  ['model-tone-amber', 'sliders horizontal', '后台托管', 'managed_model_count', formatNumber],
  ['model-tone-red', 'pause circle', '停用模型', 'disabled_model_count', formatNumber],
  ['model-tone-purple', 'server', '可用通路', 'active_channel_count', formatNumber],
  ['model-tone-teal', 'chart line', '累计 Token', 'token_count', formatTokens],
];

const ModelMetrics = ({ overview }) => (
  <section className='model-metrics'>
    {metrics.map(([tone, icon, label, key, formatter]) => (
      <div className={`model-metric ${tone}`} key={key}>
        <Icon name={icon} />
        <span>{label}</span>
        <strong>{formatter(overview?.[key])}</strong>
      </div>
    ))}
  </section>
);

export default ModelMetrics;
